module.exports = __webpack_public_path__ + "media/images/icon-info-6c5014ece561fb866a65bb56eb3dced1.svg";